import { FC, useMemo } from 'react';

import classNames from 'classnames';
import { useSwiper } from 'swiper/react';

import styles from './Slider.module.scss';

interface ISliderButtonsProps {
  isNextDisabled: boolean;
  isPrevDisabled: boolean;
  loop: boolean;
  /** Label for the navigation landmark (Slider passes e.g. "Promotions carousel navigation") */
  ariaLabel: string;
}

const SliderButtons: FC<ISliderButtonsProps> = ({
  isNextDisabled,
  isPrevDisabled,
  loop,
  ariaLabel,
}) => {
  const swiper = useSwiper();
  const prevDisabled = useMemo(() => {
    if (loop) {
      return false;
    }
    return isPrevDisabled;
  }, [loop, isPrevDisabled]);
  const nextDisabled = useMemo(() => {
    if (loop) {
      return false;
    }
    return isNextDisabled;
  }, [loop, isNextDisabled]);

  const handlePrevious = () => {
    if (prevDisabled) {
      return;
    }
    swiper.slidePrev();
  };

  const handleNext = () => {
    if (nextDisabled) {
      return;
    }
    swiper.slideNext();
  };

  return (
    <div
      aria-label={ariaLabel}
      className={styles.slider_buttons}
      role="navigation"
    >
      <button
        aria-disabled={prevDisabled}
        aria-label="Previous slide"
        className={classNames('slick-arrow slick-prev', {
          ['slick-disabled']: prevDisabled,
        })}
        disabled={prevDisabled}
        onClick={handlePrevious}
        type="button"
      >
        <span className="sr-only">Previous</span>
      </button>
      <button
        aria-disabled={nextDisabled}
        aria-label="Next slide"
        className={classNames('slick-arrow slick-next', {
          ['slick-disabled']: nextDisabled,
        })}
        disabled={nextDisabled}
        onClick={handleNext}
        type="button"
      >
        <span className="sr-only">Next</span>
      </button>
    </div>
  );
};

export { SliderButtons };
